import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink, useParams} from "react-router-dom";
import {Step} from "../types.ts";
import {I18n} from "@aws-amplify/core";


export const useStepsTableColumns = () => {

    const {id: playbookId, phaseId} = useParams();

    // Every column is sortable, and every column has an `accessor` naming the
    // field the sort keys on — `render` only controls how the cell looks.
    // The table's DEFAULT is `position` ascending, which is the step sequence
    // itself; see the comment on DEFAULT_SORT_STATUS in useSteps.ts.
    const columns: DataTableColumn<Step>[] = [
        {
            accessor: 'position',
            title: I18n.get('Position'),
            sortable: true,
            width: 80,
            render: (item: Step) => item.position,
        },
        {
            accessor: 'name',
            title: I18n.get('Name'),
            sortable: true,
            width: '1fr',
            render: (item: Step) => (
                <NavLink
                    to={`/playbooks/${playbookId ?? item.playbookId}/phases/${phaseId ?? item.phaseId}/steps/${item.id}`}
                >
                    {item.displayName || item.name}
                </NavLink>
            ),
        },
        {
            accessor: 'taskStateName',
            title: I18n.get('Task State'),
            sortable: true,
            width: '1fr',
            render: (item: Step) => item.taskStateName ?? '',
        },
        {
            accessor: 'targetService',
            title: I18n.get('Target Service'),
            sortable: true,
            width: '1fr',
            render: (item: Step) => item.targetService ?? '',
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            sortable: true,
            width: '1fr',
            render: (item: Step) => formatTimestamp(item.created),
        },
    ];


    return {
        columns,
    };
};
